<template>
    <div class="random">
		<trend-chart :datasets="datasets" :grid="grid" :labels="labels" :min="0" :interactive="true" @mouse-move="onMouseMove" class="random-chart"></trend-chart>
		<div id="pop" role="tooltip" ref="tooltip" class="tooltip" :class="{'is-active': tooltipData}">
			<div class="tooltip-container" v-if="tooltipData">
				<strong>{{labels.xLabels[tooltipData.index]}}</strong>
				<div class="tooltip-data">
					<div class="tooltip-data-item tooltip-data-item--1">{{tooltipData.data[0]}}</div>
					<div class="tooltip-data-item tooltip-data-item--2">{{tooltipData.data[1]}}</div>
					<div class="tooltip-data-item tooltip-data-item--3">{{tooltipData.data[2]}}</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import Popper from 'popper.js';

export default {
	name: 'Chart',
	props: ['datasets'],
    data() {
        return {
            // datasets: [
            //     {
            //         values comes in as props from their respective pages
            //     }
            // ],
            grid: {
                verticalLines: true,
                verticalLinesNumber: 1,
                horizontalLines: true,
                // horizontalLinesNumber: 1
            },
            labels: {
                xLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                yLabels: 5,
                yLabelsTextFormatter: val => Math.round(val * 100) / 100
            },
            tooltipData: null,
            popper: null,
            popperIsActive: false
        };
    },
    methods: {
        initPopper() {
            const chart = document.querySelector(".random-chart");
            const ref = chart.querySelector(".active-line");
            const tooltip = this.$refs.tooltip;
            this.popper = new Popper(ref, tooltip, {
                placement: "right",
                modifiers: {
                offset: { offset: "0,10" },
                    preventOverflow: {
                        boundariesElement: chart
                    }
                }
            });
        },
        onMouseMove(params) {
            this.popperIsActive = !!params;
            this.popper.scheduleUpdate();
            this.tooltipData = params || null;
        }
    },
    mounted() {
        this.initPopper();
    }
}
</script>

<style>
.random {
  width: 100%;
}
.random .vtc {
  height: 450px;
  font-size: 12px;
}
.random .labels {
  stroke: rgba(0, 0, 0, 0.05);
}
.random .active-line {
  stroke: rgba(0, 0, 0, 0.2);
}
.random .point {
  stroke-width: 2;
  transition: stroke-width 0.2s;
}
.random .point .is-active {
  stroke-width: 5;
}
.random .curve1 .stroke {
  stroke: #6BA11F; 
  stroke-width: 2;
  /* curve1: fbac91, curve2: fbe1b6, curve3: 7fdfd4 */
}
.random .curve1 .fill {
  fill: #6BA11F;
  opacity: 0.05;
}
.random .curve1 .point {
  fill: #6BA11F;
  stroke: #6BA11F;
}
.random .curve2 .stroke {
  stroke: #FFC61C;
  stroke-width: 2;
}
.random .curve2 .point {
  fill: #FFC61C;
  stroke: #FFC61C;
}
.random .curve3 .stroke {
  stroke: #7fdfd4;
  stroke-width: 2;
}
.random .curve3 .point {
  fill: #7fdfd4;
  stroke: #7fdfd4;
}
.random .tooltip {
  padding: 10px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  pointer-events: none;
}
.random .tooltip:not(.is-active) {
  display: none;
}
.random .tooltip-data {
  display: flex;
}
.random .tooltip-data-item {
  display: flex;
  align-items: center;
}
.random .tooltip-data-item:not(:first-child) {
  margin-left: 20px;
}
.random .tooltip-data-item:before {
  content: "";
  display: block;
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
.random .tooltip-data-item--1:before {
  background: #6BA11F;
}
.random .tooltip-data-item--2:before {
  background: #FFC61C;
}
.random .tooltip-data-item--3:before {
  background: #7fdfd4;
}
</style>